import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FloatingElements() {
  const [showToast, setShowToast] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    name: '',
    city: ''
  });
  const names = ['María', 'Juan', 'Sofía', 'Agustín', 'Valentina', 'Mateo', 'Camila', 'Lucas', 'Martina', 'Tomás'];
  const cities = ['Mendoza', 'Córdoba', 'Rosario', 'CABA', 'La Plata', 'Tucumán', 'Salta', 'Mar del Plata', 'Neuquén', 'Santa Fe'];
  useEffect(() => {
    // Show static toast after 2 seconds
    const toastTimer = setTimeout(() => {
      setShowToast(true);
    }, 2000);
    // Show random popup periodically
    const popupInterval = setInterval(() => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setPopupData({
        name: randomName,
        city: randomCity
      });
      setShowPopup(true);
      // Hide popup after 5 seconds
      setTimeout(() => {
        setShowPopup(false);
      }, 5000);
    }, 15000); // Every 15 seconds
    return () => {
      clearTimeout(toastTimer);
      clearInterval(popupInterval);
    };
  }, []);
  return <>
      {/* Static Toast (Bottom Right) */}
      <AnimatePresence data-id="element-182">
        {showToast && <motion.div initial={{
        opacity: 0,
        y: 50,
        x: 50
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} className="fixed bottom-4 right-4 z-50 bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4 max-w-sm w-[calc(100%-2rem)] md:w-auto" data-id="element-183">
            <div className="flex items-center gap-3" data-id="element-184">
              <div className="w-10 h-10 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold text-sm shrink-0" data-id="element-185">
                LG
              </div>
              <div data-id="element-186">
                <div className="font-bold text-slate-800 text-sm" data-id="element-187">
                  Lucas G. · Córdoba
                </div>
                <div className="text-xs text-brand-blue font-medium mb-0.5" data-id="element-188">
                  ✅ Médico en Proceso™ — Nivel 1
                </div>
                <div className="text-xs text-slate-500" data-id="element-189">
                  Compra confirmada · hace 2 min
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Random Purchase Popup (Bottom Left) */}
      <AnimatePresence data-id="element-190">
        {showPopup && <motion.div initial={{
        opacity: 0,
        y: 50,
        x: -50
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 50,
        x: -50
      }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-slate-200 p-4 max-w-sm w-[calc(100%-2rem)] md:w-auto" data-id="element-191">
            <div className="flex items-start gap-3" data-id="element-192">
              <div className="text-2xl shrink-0 mt-1" data-id="element-193">🛍️</div>
              <div data-id="element-194">
                <div className="text-sm text-slate-800" data-id="element-195">
                  <span className="font-bold" data-id="element-196">{popupData.name}</span> de{' '}
                  <span className="font-bold" data-id="element-197">{popupData.city}</span> acaba de
                  comprar este libro digital
                </div>
                <div className="text-xs text-slate-500 mt-1" data-id="element-198">
                  hace unos instantes
                </div>
              </div>
              <button onClick={() => setShowPopup(false)} className="text-slate-400 hover:text-slate-600 ml-2" data-id="element-199">
                ×
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}